import React, { Component } from 'react'
import { dateHelper } from '../../../../../../../src/helpers/date.helper'
import {
	BoxList,
	Item,
} from './list.style'

class List extends Component {
	constructor(props) {
		super(props)
	}
	render() {
		const { extract } = this.props
		return (
			<BoxList>
				{extract.map((v, i) => {
					var className = v.operation == 'Débito' ? 'trDebit' : v.description == 'Pagamento recebido' ? 'trPayment' : 'trCredit';
					return (
						<li key={i} className={className}>
							<Item>
								<li className={className}>
									<div>
										<small>
											{dateHelper.formatDefault(new Date(v.transactionDate))} {dateHelper.getHours(new Date(v.transactionDate))}
										</small>
										<p>{v.orderNumber} - {v.description}</p>
									</div>
								</li>
								<li className={className}>
									{v.value ? v.value.$toReais() : ''}
								</li>
							</Item>
						</li>
					)
				})}
			</BoxList>
		)
	}
}

export default List
